import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { AssessmentError } = await import('./index');
    return {
        Component: AssessmentError,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
